<template>
  <div class="content">
    <div class="main-content">
      <p class="title" v-if="content.title">{{ content.title }}</p>
      <p class="author" v-if="content.author">{{ content.author }}</p>
      <p class="content">{{ content.content }}</p>
      <p class="signature" v-if="content.createDate">{{ content.createDate }}</p>
      <img-list v-if="content.imgs.length>0" :imgs="content.imgs"/>
    </div>
    <split/>
    <div class="extra-content">
      <p class="rhyme" v-if="content.rhymeInfo">〖韵〗{{ content.rhymeInfo }}</p>
      <p class="rule" v-if="content.ruleInfo">〖律〗{{ content.ruleInfo }}</p>
      <p class="rule" v-if="content.preface">〖按〗{{ content.preface }}</p>
      <p class="rule" v-if="content.annotation">〖注〗{{ content.annotation }}</p>
    </div>
  </div>
</template>

<script>
  import Split from 'common/comps/split/Split'
  import ImgList from 'common/comps/img-list/ImgList'

  export default {
    name: 'VerseContent',
    props: {
      content: Object
    },
    components: {
      Split,
      ImgList
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~stylus/variable"

  .content
    .main-content
      padding-bottom 8px
      .title
        line-height: 18px
        margin-top: 12px
        margin-bottom: 12px
        font-size: $fontsize-large
        color: $color-dark-grey
      .author
        line-height: 18px
        padding: 0 24px
        font-size: $fontsize-medium
        color: $color-grey
      .content
        line-height: 180%
        padding: 8px
        font-size: $fontsize-large
        color: $color-dark-grey
        white-space: pre-wrap
      .signature
        font-size: $fontsize-large
        color: $color-dark-grey
        margin-left 8px
        margin-bottom 8px

    .extra-content
      padding 8px 0
      p
        line-height: 22px
        padding: 4px
        font-size: $fontsize-medium
        color: $color-grey
        text-align justify
</style>
